<template>
  <div class="cd-rate-calculator">
    <rate-calculator 
      :zipcode="zipcode" 
      :longitude="longitude" 
      :latitude="latitude" 
      :disclosure="disclosure" 
      :disclaimer="disclaimer">
    </rate-calculator>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CDRateCalculator from "./components/cdRateCalculator.vue";

export default {
  data() {
    return {
      zipcode: this.locZip,
      latitude: this.locLat,
      longitude: this.locLong,
      disclaimer: this.openAccountDisclaimer,
      disclosure: this.disclosureText
    }
  },
  mounted() {
  },
  components: {
    "rate-calculator": CDRateCalculator
  },
  methods: {
    ...mapActions([
    ]),
    renderCards() {

    }
  },
  props: {
    locLong: String,
    locLat: String,
    locZip: String,
    openAccountDisclaimer: String,
    disclosureText: String
  }
};
</script>
